var _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUs = function SvgUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7410 3900"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b22234",
    d: "M0 0h7410v3900H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0",
    stroke: "#fff",
    strokeWidth: 300
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b6e",
    d: "M0 0h2964v2100H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "us_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "us_svg__c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "us_svg__e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "us_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "us_svg__a",
    d: "m247 90 70.534 217.082-184.66-134.164h228.253L176.466 307.082z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__a",
    y: 420
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__a",
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__a",
    y: 1260
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__a",
    y: 1680
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__b",
    x: 247,
    y: 210
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__c",
    x: 494
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__d",
    x: 988
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__c",
    x: 1976
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#us_svg__e",
    x: 2470
  }))));
};

export default SvgUs;